// extracted by mini-css-extract-plugin
var _1 = "body--HQk3S thinScrollbar--Y0v0z";
var _2 = "cancelButton--peHVt";
var _3 = "closeButton--XPKd2";
var _4 = "footer--R4gb_";
var _5 = "header--jpRxq";
var _6 = "headerContent--My29I";
var _7 = "modal--WSnh1";
var _8 = "overlay--Vch0h";
var _9 = "submitButton--b9QdU";
var _a = "submitButtonDanger--s80uz";
var _b = "subtitle--Ys4dH";
var _c = "title--qcZ0A";
export { _1 as "body", _2 as "cancelButton", _3 as "closeButton", _4 as "footer", _5 as "header", _6 as "headerContent", _7 as "modal", _8 as "overlay", _9 as "submitButton", _a as "submitButtonDanger", _b as "subtitle", _c as "title" }
